<button
class="ui-button ui-widget ui-state-default ui-corner-all ng-star-inserted ui-button-text-only go-back-btn"
pbutton
type="button"
(click)="goBack()">
  <i class="fa fa-chevron-left"></i>
  <span>{{'campaign.goBack' | translate}}</span>
</button>



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/go-back-button/go-back-button.component.html